import axios from 'axios';
import { getQuery } from '@utils/tools';

const vechainSDK = require('toolchain-landingpage-web-sdk');

export const fetch = (params) => {
  const Query = getQuery();
  return new Promise((resolve, reject) => {
    vechainSDK.fetch({
      vid: params.vid || Query.vid,
      types: params.types,
      language: params.language,
    }).then(res => {
      if (res && 'jsonData' in res) {
        resolve(res);
      }
    }).catch(err => {
      reject(err);
    });
  })
}

// const network = axios.create();
// const fetchConfig = () => network.get('/static/config.json');

// 获取当前最新区块
export const getBlockBest = () => {
  const blocksUrl = 'https://vethor-node.digonchain.com/blocks/best';
  return new Promise((resolve, reject) => {
    axios.get(blocksUrl).then((res) => {
      resolve(res);
    }).catch((err) => {
      reject(err);
    });
  });
}

// 根据 txId 获取 transactions 信息
export const getTransactionsInfo = txId => {
  const txIdUrl = 'https://vethor-node.digonchain.com/transactions';
  return new Promise((resolve, reject) => {
    axios.get(`${txIdUrl}/${txId}`).then((res) => {
      resolve(res);
    }).catch((err) => {
      reject(err);
    });
  });
}